import script from "./Birthday.vue?vue&type=script&setup=true&lang=js"
export * from "./Birthday.vue?vue&type=script&setup=true&lang=js"

import "./Birthday.vue?vue&type=style&index=0&id=475dfa3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475dfa3e"]])

export default __exports__